import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin, components } from 'aws-amplify-vue'

import config from '~/config'

Amplify.configure(config.awsConfig)

Vue.use(AmplifyPlugin, AmplifyModules)
Vue.component(components)
